import React from 'react';
import { Button, Col, FormGroup, Row } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../context';
import { Form, Field } from 'react-final-form';

// TODO: refactor later
function EditPracticeRelationsForm(props) {
    const {
        practiceName,
        practiceId,
        submitCB = () => {},
        closeCB = () => {},
        conversion = {},
    } = props;

    const dispatch = useDispatch();

    const allPims = useSelector(
        (state) => state.pims.allPims,
        allPimsEqualityCheck
    );

    let otherPimIds = [];

    const saveOffering = async (values) => {
        if (!otherPimIds.includes(values.sourcePims))
            values.sourcePimsName = null;
        dispatch(
            actions.conversions.updateSourcePims({
                conversionId: conversion.id,
                sourcePims: values.sourcePims,
                sourcePimsName: values.sourcePimsName,
            })
        ).then(() => {
            Promise.all([
                dispatch(actions.notes.fetchNotes(practiceId)),
                dispatch(actions.toggle.triggerRefresh()),
                dispatch(actions.toggle.triggerPracticeRefresh()),
                dispatch(actions.toggle.activitiesRefresh()),
            ]).then(() => {
                submitCB();
            });
        });
    };

    return (
        <Form
            initialValues={{ ...conversion }}
            onSubmit={saveOffering}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form
                    id="editPracticeRelationsForm"
                    onSubmit={handleSubmit}
                    className="w-100">
                    <Row>
                        {/* we want to show Practice, Conversion detials, and then allow them to change the pims. if other, change the name */}
                        <Col xs="12">
                            <p>Practice: {practiceName}</p>
                        </Col>
                        <Col xs="12">
                            <p>Partner: {conversion.partner}</p>
                        </Col>
                        <Col xs="12">
                            <p>Offering: {conversion.offering}</p>
                        </Col>
                    </Row>
                    <FormGroup row>
                        <Col md="6">
                            <label htmlFor="offering" className="d-block">
                                Converting from PIMS:
                                <br />
                                <Field
                                    name="sourcePims"
                                    id="sourcePims"
                                    component="select"
                                    className="w-100 p-2 rounded"
                                    required>
                                    <option />
                                    <optgroup label="Integration Supported">
                                        {(allPims || [])
                                            .filter(
                                                (p) => p.supportsConnectivity
                                            )
                                            .map((p, x) => (
                                                <option key={x} value={p.id}>
                                                    {p.name}
                                                </option>
                                            ))}
                                    </optgroup>
                                    <optgroup label="Manually Supported">
                                        {(allPims || [])
                                            .filter(
                                                (p) =>
                                                    !p.supportsConnectivity &&
                                                    p.name !== `Other`
                                            )
                                            .map((p, x) => (
                                                <option key={x} value={p.id}>
                                                    {p.name}
                                                </option>
                                            ))}
                                    </optgroup>
                                    <optgroup label="Not Listed">
                                        {(allPims || [])
                                            .filter(
                                                (p) =>
                                                    !p.supportsConnectivity &&
                                                    p.name === `Other`
                                            )
                                            .map((p, x) => {
                                                otherPimIds.push(p.id);
                                                return (
                                                    <option
                                                        key={x}
                                                        value={p.id}>
                                                        {p.name} (Specify)
                                                    </option>
                                                );
                                            })}
                                    </optgroup>
                                </Field>
                            </label>
                        </Col>
                        {otherPimIds.includes(values.sourcePims) && (
                            <Col md="6">
                                <label
                                    htmlFor="customPartnerId"
                                    className="d-block">
                                    "Other" PIMS name
                                    <br />
                                    <Field
                                        id="sourcePimsName"
                                        name="sourcePimsName"
                                        component="input"
                                        className="w-100 p-2 rounded border-0"
                                        required></Field>
                                </label>
                            </Col>
                        )}
                    </FormGroup>
                    <Row className="justify-content-end pt-3">
                        <Button
                            color="danger"
                            className="mr-3"
                            onClick={closeCB}>
                            Cancel
                        </Button>
                        <Button
                            color="success"
                            type="submit"
                            disabled={submitting || pristine}>
                            Save
                        </Button>
                    </Row>
                </form>
            )}
        />
    );
}
const allPimsEqualityCheck = (newPimsList, oldPimsList) => {
    if (!newPimsList || !oldPimsList) return false;
    if (newPimsList?.length !== oldPimsList?.length) return false;
    if (newPimsList?.length === 0 && oldPimsList?.length === 0) return true;
    const pimsEqualityCheck = (oldPims) => {
        const template = {
            id: '',
            name: '',
        };
        const oldState = Object.assign(
            {},
            template,
            ...Object.keys(template).map(
                (k) => k in oldPims && { [k]: oldPims[k] }
            )
        );

        const comparePims = (newPims) => {
            const newState = Object.assign(
                {},
                template,
                ...Object.keys(template).map(
                    (k) => k in newPims && { [k]: newPims[k] }
                )
            );
            return shallowEqual(oldState, newState);
        };
        const check = newPimsList?.find(comparePims);
        return check !== undefined;
    };
    const comparedPimsList =
        !!oldPimsList.length && oldPimsList?.every(pimsEqualityCheck);

    const isSamePimsList = !!newPimsList.length && comparedPimsList;

    return isSamePimsList;
};

export default EditPracticeRelationsForm;
